<template lang="pug">
div
  div(v-if="!error && !loading")
    div.form-header
      div.row.form-title
        div.col-xs-12
          h1.text-center {{title}}
      div.row.form-description
        p.col-xs-12 {{description}}
    div.row.form-body
      vue-form-generator.col-xs-12( ref="vfg" :schema="schema" :model="model" :options="formOptions")
    div.row.form-footer
      div.col-xs-12
        button.btn.btn-primary.submit-button(
          style="margin-top: 2vh; margin-bottom: 2vh; margin-right: 2vw;"
          @click="formSubmit"
          :disabled="loading"
        ) Submit
  spinner(v-else-if="loading" v-model="loading")
  div(v-else)
    error-page(:error="error")
</div>
</template>

<script>
import VueFormGenerator from "vue-form-generator"; // eslint-disable-line  no-unused-vars
import ErrorPage from "./ErrorPage.vue";
import AttachmentValidator from "../mixins/validators/attachment.js";
import NumberValidator from "../mixins/validators/number.js";
import FormSubmit from "../mixins/FormSubmit.js";
import FormLoad from "../mixins/FormLoad.js";
import HandleError from "../mixins/HandleError.js";
import Spinner from "@/components/Spinner.vue";

const formOptions = {
  validateAfterChanged: true
};

export default {
  name: "Form",
  components: {
    ErrorPage,
    Spinner
  },
  mixins: [
    AttachmentValidator,
    NumberValidator,
    FormSubmit,
    FormLoad,
    HandleError
  ],
  data() {
    return {
      // Passed to Vue form generator
      formOptions,
      model: null,

      // Used to generate fields
      questions: [],

      // used when submitting form results. Will equal param.formId unless otherwise
      //   set by information from server
      submitId: null,

      title: "",
      description: "",

      // Toggle loading display
      loading: true,
      loadError: null,
      error: false
    };
  },
  computed: {
    fields() {
      return this.questions.map(field => {
        // Space out quesitons with extra margins
        field.styleClasses = ["spaced-question"];

        // Add validator rules where necessary
        if (field.required) {
          field.validator = "required";
          if (field.type === "checkbox") {
            field.validator = value => (value ? [] : ["Must be checked"]);
          }
        }

        if (field.dataType === "attachment") {
          field.validator = this.validateAttachment;
          field.hint = `Maximum attachment size: 4MB. ${field.hint || ""}`;
        }

        // Add validators for numbers
        if (field.dataType === "number") {
          field.validator = this.validateNumber(field);
        }

        // Add custom styles for nonQuestion items
        if (field.type === "label" && field.addSeparator) {
          if (
            field.separatorPosition === "above" ||
            field.separatorPosition === "both"
          ) {
            field.styleClasses.push("spacer-before");
          }
          if (
            field.separatorPosition === "below" ||
            field.separatorPosition === "both"
          ) {
            field.styleClasses.push("spacer-after");
          }
        }

        // Add custom select method if using pikaday datepicker
        if (field.type === "pikaday") {
          const that = this;
          field.pikadayOptions.onSelect = date => {
            that.$set(this.model, field.model, date);
          };
        }

        return field;
      });
    },
    schema() {
      return {
        fields: this.fields
      };
    }
  },
  created() {
    this.formLoad();
  }
};
</script>
<style lang="scss">
.form-group.field-checkbox {
  display: flex;
  flex-wrap: wrap;
  div.field-wrap {
    order: 1;
  }
  label {
    order: 2;
    padding-left: 10px;
  }
  div.errors {
    order: 3;
  }
}

.form-group > label {
  font-size: 1.2em;
}

.spaced-question {
  margin-top: 2vh;
}

.spacer-before:before {
  content: " ";
  display: block;
  border-bottom: 1px solid #bcbcbc;
  margin-bottom: 20px;
}

.form-header {
  min-height: 20vh;
  .form-title {
    margin-top: 1vh;
  }
  .form-description {
    margin-top: 2vh;
  }
}

.form-body {
  min-height: 40vh;
}

.form-footer {
  min-height: 50px;
}

.spacer-after:after {
  content: " ";
  display: block;
  border-bottom: 1px solid #bcbcbc;
  padding-top: 15px;
}
.submit-button {
  padding: 8px 25px 8px 25px;
}
</style>
